import { useLanguage } from "@tlc/ls2pac/components/Language";
import { HostSystemItemView } from "@tlc/ls2pac/dto/HostSystemItemView";
import React from "react";

export const HoldPickupByDate = ({ hold }: { hold: HostSystemItemView }) => {
  const { translate } = useLanguage();
  if (hold.status === "AR" && !hold.suspendUntilDate && hold.holdPickupBy) {
    return (
      <>
        {translate("by")} <strong>{hold.holdPickupByString}</strong>
      </>
    );
  }
  return null;
};

export const PhysicalHoldPickupInfo: React.FC<{ hold: HostSystemItemView }> = ({
  hold,
}) => {
  const { translate } = useLanguage();
  return (
    <>
      {!hold.downloadable && (
        <div>
          {translate("pickupLocation")} <strong>{hold.holdPickupBranch}</strong>{" "}
          <HoldPickupByDate hold={hold} />
        </div>
      )}
    </>
  );
};
